import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import get from 'lodash/get'

import Comments from '@components/Comments'

class EPLCommentSidebar extends Component {
  static propTypes = {
    eplModel: PropTypes.object,
    expert: PropTypes.object,
    projectStatusId: PropTypes.number,
    staticData: PropTypes.object
  }

  componentWillUnmount () {
    this.props.eplModel.get()
  }

  render () {
    const { eplModel, expert, projectStatusId, staticData } = this.props
    const { CLOSED } = staticData.CONST.PROJECT_STATUSES
    const nonEditable = projectStatusId === CLOSED
    return (
      <div>
        <h1>
          {get(expert, 'title', '')} {get(expert, 'fullName', '')}
        </h1>
        <Comments
          modelId={eplModel.id}
          model='expert_project_link'
          nonEditable={nonEditable}
          markAllAsSeen
        />
      </div>
    )
  }
}

export default inject('staticData')(observer(EPLCommentSidebar))
